<template>
  <v-dialog
    v-model="dialog"
    max-width="1370px"
    width="90%"
    scrollable
    :fullscreen="fullscreen()"
    transition="dialog-bottom-transition"
  >
    <v-card
      tile
      class="kiosk-view-dialog"
    >
      <v-toolbar
        flat
        dark
        color="teal"
        height="60px"
        style="max-height: 60px"
      >
        <span>Kiosk: <b>{{ entity.name }}</b></span>

        <v-spacer />
        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>

        <v-sheet
          elevation="6"
          rounded
          class="mx-auto pa-4 mt-5 overflow-hidden"
        >
          <header class="v-sheet v-sheet--tile theme--dark v-toolbar v-toolbar--flat teal" style="max-width: none; height: 40px; max-height: 40px; margin: -16px -16px 10px;">
            <div class="v-toolbar__content" style="height: 40px;">
              <span>Info</span>
            </div>
          </header>

          <v-row class="mx-0">
            <v-text-field
              v-model="entity.name"
              label="Name"
              hide-details
              :readonly="loading || !$store.state.auth.checkAccess({key: 'kiosk.entity.crud', value: true})"
              class="mr-4"
            />

            <v-text-field
              v-model="entity.host"
              label="Host"
              hide-details
              :readonly="loading || !$store.state.auth.checkAccess({key: 'kiosk.entity.crud', value: true})"
              class="mr-4"
            />

            <v-text-field
              v-if="!create"
              v-model="entity.prefix"
              label="Prefix"
              class="mr-4"
              readonly
              disabled
              hide-details
            />

            <v-autocomplete
              label="Parent"
              v-model="entity.parent_id"
              :readonly="loading || !$store.state.auth.checkAccess({key: 'kiosk.entity.crud', value: true})"
              :return-object="false"
              :items="entityList(entity)"
              hide-details
              item-value="value"
              item-text="text"
              auto-select-first
              class="mr-4"
            />

            <v-checkbox
              v-model="entity.frozen"
              label="Frozen"
              hide-details
              :readonly="loading || !$store.state.auth.checkAccess({key: 'kiosk.entity.crud', value: true})"
              class="mr-4"
              :style="{'width': $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? '100%' : false}"
            />

            <v-text-field
              v-if="!create"
              v-model="entity.created"
              label="Created"
              hide-details
              class="mr-4"
              readonly
              disabled
            />

            <v-text-field
              v-if="!create"
              v-model="entity.updated"
              label="Updated"
              hide-details
              readonly
              disabled
            />
          </v-row>
          <v-row class="px-4 pt-4 kiosk-view-dialog_footer">
            <v-textarea
              v-model="entity.description"
              label="Description"
              small
              auto-grow
              :readonly="!$store.state.auth.checkAccess({key: 'kiosk.entity.crud', value: true})"
              rows="2"
              hide-details
            />
            <v-spacer v-if="$vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm'" />
            <v-divider v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'" class="col-12 mt-3 mb-3" style="border: none;" />
            <v-btn
              v-if="$store.state.auth.checkAccess({key: 'kiosk.entity.crud', value: true})"
              color="teal darken-1"
              small
              dark
              :loading="loading"
              @click="save()"
            >
              Save
            </v-btn>
          </v-row>
        </v-sheet>

        <v-sheet
          elevation="6"
          rounded
          class="mx-auto pa-4 mt-5 overflow-hidden"
          v-if="!entity.unlimited && !create"
        >
          <header class="v-sheet v-sheet--tile theme--dark v-toolbar v-toolbar--flat teal" style="max-width: none; height: 40px; max-height: 40px; margin: -16px -16px 10px;">
            <div class="v-toolbar__content" style="height: 40px;">
              <span>Balances</span>
            </div>
          </header>

          <v-row class="mx-0 mt-2 mb-0 pb-0 " style="min-height: 55px;">
            <template v-for="balance in entity.wallet">
              <v-text-field
                :prefix="balance.currency"
                v-model="balance.balance"
                hide-details
                style="max-width: 150px"
                class="mr-4 kiosk-balances"
                disabled
                readonly
              ></v-text-field>
            </template>
            <v-spacer />
            <v-col
              v-if="$store.state.auth.checkAccess({key: 'kiosk.entity.transfer_funds', value: true})"
              class="pa-0"
              :cols="$vuetify.breakpoint.name != 'xs' ? false : 12"
              :style=" $vuetify.breakpoint.name != 'xs' ? 'max-width: 400px; min-width: 400px': ''"
            >
              <v-row class="ma-0" :style="{'padding-left': $store.state.auth.user.settings.base != entity.entity_id ? 0 : '100px'}">
                <v-btn
                  v-if="$store.state.auth.user.settings.base != entity.entity_id"
                  color="teal darken-1"
                  :class=" $vuetify.breakpoint.name != 'xs' ? 'mt-4 mr-4' : ' mt-4 mb-3 col-12' "
                  small
                  :loading="loading"
                  :dark="!create"
                  :disabled="create"
                  @click="transaction('deposit')"
                >
                  Deposit
                </v-btn>

                <v-text-field
                  required
                  label="Amount"
                  type="number"
                  hide-details
                  :rules="[v => !!v || 'Amount is required']"
                  v-model="balance.amount"
                  :disabled="create"
                  :style=" $vuetify.breakpoint.name != 'xs' ? 'z-index: 800; max-width: 105px' : '' "
                />

                <v-select
                  v-model="balance.currency"
                  :items="currencies"
                  :rules="[v => !!v || 'Currency is required']"
                  label="Currency"
                  required
                  :disabled="create"
                  :style=" $vuetify.breakpoint.name != 'xs' ? 'z-index: 800; max-width: 75px' : '' "
                />

                <v-btn
                  color="teal lighten-2"
                  :class=" $vuetify.breakpoint.name != 'xs' ? 'mt-4 ml-4' : 'col-12' "
                  small
                  :loading="loading"
                  :dark="!create"
                  :disabled="create"
                  @click="transaction('withdraw')"
                >
                  Withdraw
                </v-btn>
              </v-row>
            </v-col>
          </v-row>

          <v-divider />
          <v-data-table
            v-if="!create"
            :loading="transaction_history.loading"
            :headers="transaction_history.headers"
            :items="transaction_history.items"
            :options.sync="transaction_history.options"
            :server-items-length="transaction_history.total"
            sort-desc
            max-height="350px"
            :footer-props="{'items-per-page-options': [5, 25, 50, 100]}"
            :items-per-page="5"
            mobile-breakpoint="0"
            class="col-12 pa-0"
          />
        </v-sheet>
        <v-sheet
          v-if="!create"
          elevation="6"
          rounded
          class="mx-auto pa-4 mt-5 overflow-hidden"
        >
          <header class="v-sheet v-sheet--tile theme--dark v-toolbar v-toolbar--flat teal" style="max-width: none; height: 40px; max-height: 40px; margin: -16px -16px 10px;">
            <div class="v-toolbar__content" style="height: 40px;">
              <span>Operators</span>
            </div>
          </header>

          <v-row class="mx-0 mt-2 mb-0 pb-0" style="min-height: 55px;">
            <v-data-table
              :loading="users.loading"
              :headers="users.headers"
              :items="users.items"
              sort-desc
              max-height="350px"
              hide-default-footer
              mobile-breakpoint="0"
              :items-per-page="-1"
              class="col-12 pa-0"
            >
              <template v-slot:item.action="{ item }">

                <v-btn
                  v-if="item.status != 'blocked' && $store.state.auth.checkAccess({key: 'kiosk.user.create', value: true}) && $store.state.auth.user.settings.base != entity.entity_id"
                  color="teal"
                  @click="blockUser(item)"
                  icon
                  title="Block account"
                  class="mr-5"
                >
                  <v-icon>mdi-account-cancel</v-icon>
                </v-btn>
                <v-btn
                  v-if="item.status != 'blocked' && $store.state.auth.checkAccess({key: 'kiosk.user.create', value: true}) && $store.state.auth.user.settings.base != entity.entity_id"
                  color="teal"
                  @click="loginAs(item)"
                  icon
                  title="Login as Operator"
                >
                  <v-icon>mdi-account-arrow-right</v-icon>
                </v-btn>
              </template>

              <template v-slot:body.prepend>
                <tr v-if="$store.state.auth.checkAccess({key: 'kiosk.user.create', value: true})">
                  <td
                    :colspan="users.headers.length"
                  >
                    <v-row v-if="!users.newUser">
                      <v-btn
                        color="teal"
                        dark
                        small
                        :dark="!create"
                        :disabled="create"
                        @click="users.newUser = {}"
                        class="ma-auto"
                      >
                        <v-icon>mdi-plus</v-icon>
                        Add User
                      </v-btn>
                    </v-row>

                    <v-row v-if="users.newUser" class="mx-3 mb-4">
                      <v-text-field
                        label="Surname"
                        v-model="users.newUser.surname"
                        :rules="[v => !!v || 'Surname is required']"
                        class="mr-3"
                        style="max-width: 180px"
                      />
                      <v-text-field
                        label="Name"
                        v-model="users.newUser.name"
                        :rules="[v => !!v || 'Name is required']"
                        required
                        class="mr-3"
                        style="max-width: 220px"
                      />
                      <v-text-field
                        label="Login"
                        v-model="users.newUser.login"
                        :rules="[v => !!v || 'Login is required']"
                        required
                        class="mr-3"
                        @change="users.newUser.customLogin = users.newUser.login.length > 0"
                        style="max-width: 250px"
                      />
                      <v-text-field
                        label="Password"
                        v-model="users.newUser.password"
                        :rules="[v => !!v || 'Password is required']"
                        required
                        counter
                        class="mr-3"
                        style="max-width: 200px"
                      />
                      <v-select
                        v-model="users.newUser.currency"
                        :items="currencies"
                        :rules="[v => !!v || 'Currency is required']"
                        label="Currency"
                        required
                        style="z-index: 800; max-width: 100px;"
                        class="mr-3"
                      ></v-select>
                      <v-select
                        label="Status"
                        v-model="users.newUser.status"
                        :items="users.statuses"
                        class="mr-3"
                        style="max-width: 110px"
                      />
                      <v-select
                        label="Type"
                        v-model="users.newUser.role_id"
                        :items="users.roles"
                        style="max-width: 150px"
                      />
                      <v-text-field
                        label="Email"
                        v-model="users.newUser.email"
                        :rules="[v => !!v || 'Email is required']"
                        required
                        class="mr-3"
                        style="max-width: 270px; width: 270px"
                      />
                      <v-text-field
                        label="Phone"
                        v-model="users.newUser.phone"
                        :rules="[v => !!v || 'Phone is required']"
                        required
                        class="mr-3"
                        style="max-width: 240px"
                      />
                      <v-text-field
                        label="IP"
                        v-model="users.newUser.ip"
                        class="mr-3"
                        hint="Use comma as delimiter"
                      />

                      <v-btn
                        color="teal"
                        dark
                        small
                        @click="saveUser"
                        class="mt-4"
                        style=""
                      >
                        Save
                      </v-btn>
                    </v-row>
                  </td>
                  <!--                  <td v-if="users.newUser" width="60">-->
                  <!--                  </td>-->
                </tr>
              </template>

            </v-data-table>

          </v-row>
        </v-sheet>

      </v-card-text>
      <v-card-actions style="border-top: 1px solid teal">
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
    <template>
      <v-dialog
        v-model="users.createdModal"
        width="500"
      >
        <v-card>
          <v-card-title
            class="headline teal lighten-2 theme--dark white--text"
            primary-title
          >
            Operator Created
          </v-card-title>

          <v-card-text class="pt-4">
            <h3>Login: {{ users.newUser.login }}</h3>
            <h3>Password: {{ users.newUser.password }}</h3>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <h5 class="">For secure transfer data use: <a href="https://privnote.com/">https://privnote.com/</a></h5>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="users.createdModal = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-dialog>
</template>

<style>
  .kiosk-view-dialog .kiosk-balances.theme--light.v-input--is-disabled,
  .kiosk-view-dialog .kiosk-balances.theme--light.v-input input,
  .kiosk-view-dialog .kiosk-balances.theme--light.v-input textarea {
    color: rgba(0, 0, 0, 0.87);
  }

  .kiosk-view-dialog .kiosk-balances.v-text-field > .v-input__control > .v-input__slot:after,
  .kiosk-view-dialog .kiosk-balances.v-text-field > .v-input__control > .v-input__slot:before {
    /*border: none !important;*/
  }

  .kiosk-view-dialog_footer {
    position: relative;
  }

  .kiosk-view-dialog_footer > button {
    position: absolute;
    bottom: 0;
    right: 10px;
  }

</style>

<script>
  import { cloneDeep, isObject, isArray, get, map } from 'lodash'
  import { API } from '@/utils/api'

  export default {

    props: [ 'entityList', 'loadEntities', 'currencies' ],

    components: {},

    data: () => ({
      create: false,
      dialog: false,
      transaction_history: {
        loading: false,
        total: 0,
        options: {
          itemsPerPage: 5
        },
        items: [],
        headers: [
          { text: 'ID', value: 'transaction_history_id', sortable: true },
          { text: 'From', value: 'from', sortable: false },
          { text: 'Name', value: 'name', sortable: true },
          { text: 'Login', value: 'login', sortable: true },
          { text: 'Amount', value: 'amount', sortable: true },
          { text: 'Currency', value: 'currency', sortable: true },
          { text: 'Type', value: 'type', sortable: true },
        ]
      },
      users: {
        loading: false,
        statuses: [ { text: 'Active', value: 'active' }, { text: 'Disable', value: 'blocked' } ],
        types: [],
        user: false,
        newUser: false,
        createdModal: false,
        items: [],
        headers: [
          { text: 'ID', value: 'user_id', sortable: true },
          // { text: 'Name', value: 'name', sortable: true },
          { text: 'Login', value: 'login', sortable: true },
          { text: 'Email', value: 'email', sortable: true },
          { text: 'Status', value: 'status', sortable: true },
          { text: 'Type', value: 'type', sortable: true },
          { text: '', value: 'action', sortable: false },
        ]
      },
      loading: false,
      entity: {},
      entityInit: {},
      balance: {
        amount: 10,
        currency: 'EUR'
      }
    }),

    computed: {},

    watch: {
      'transaction_history.options': function () {
        this.loadTransactionHistory()
      },

      'users.createdModal': function (val) {
        if (!val) {
          this.users.newUser = false
        }
      },

      'users.newUser': function () {
        if (this.users.newUser) {
          if (!this.users.newUser.password) {
            this.users.newUser.password = (Math.random().toString(36) + '00000000000000000').slice(2, 8).toUpperCase() + (Math.random().toString(36) + '00000000000000000').slice(2, 8)
          }
          if (!this.users.newUser.status) {
            this.users.newUser.status = 'active'
          }
          if (!this.users.newUser.type) {
            // this.users.newUser.type = 'cashier'
          }
          if (!this.users.newUser.ip) {
            this.users.newUser.ip = '*'
          }
        }
      },
      'users.newUser.surname': function () {
        this.generateLogin()
      },
      'users.newUser.name': function () {
        this.generateLogin()
      },
    },

    methods: {

      loginAs (user) {
        return API.call('/kiosk/users/login_as.json', { entity_id: this.entity_id, ...user }, null, null).then(resp => {

          this.$notification.show = true
          this.$notification.message = `You have successfully login as ${user.name} (${user.login})`
          this.$notification.type = 'success'

          this.loadRoles()
          return this.$store.dispatch('auth/checkSession', {})
        }).catch(e => {
        }).finally(() => {
          this.loading = false
          this.loadEntities()
        })
      },

      generateLogin () {
        if (this.users.newUser && (this.users.newUser.surname || this.users.newUser.name) && !this.users.newUser.customLogin) {
          this.users.newUser.login = _.trim(((this.users.newUser.surname || '') + '.' + ((this.users.newUser.name || '')[0] || '')), '.').toLowerCase()
        }
      },

      fullscreen () {
        return window.innerWidth <= 1440
      },

      open (entity_id, create = false) {
        this.users.newUser = false
        this.dialog = !this.dialog
        this.create = create
        this.transaction_history.total = 0
        this.transaction_history.items = []
        this.users.items = []
        this.transaction_history.options.page = 1
        if (!create) {
          this.action = 'update'
          this.entity_id = entity_id
          this.loadInfo()
        } else {
          this.action = 'create'
          this.entity = {}
          this.entityInit = {}
        }
        this.loadRoles()
        // this.loadReportList()
      },

      // loadReportList () {
      //   this.reports.items = []
      //   this.reports.reportsTabModel = null
      //   return API.call('/kiosk/reports/list.json', {}, null, null).then(resp => {
      //
      //     this.reports.items = get(resp, 'data', [])
      //
      //     return resp.data
      //   }).catch(e => {
      //     this.$notification.show = true
      //     this.$notification.message = e.response.data.message
      //     this.$notification.type = 'error'
      //   }).finally(() => {
      //     this.loading = false
      //   })
      // },

      loadRoles () {
        this.loading = true
        return API.call('/users/role/list.json').then(resp => {
          this.users.roles = map(resp.data, (o) => ({ text: o.name, value: o.role_id }))
          // }).catch(e => {
          //   this.$notification.show = true
          //   this.$notification.message = get(e, 'response.data.message', get(e, 'message'))
          //   this.$notification.type = 'error'
        }).finally(() => {
          this.loading = false
        })
      },

      loadTransactionHistory () {
        if (this.create) {
          return
        }
        this.transaction_history.items = []
        this.transaction_history.loading = true
        return API.call('/kiosk/entities/transaction_history.json', { entity_id: this.entity_id, ...this.transaction_history.options }).then(resp => {

          this.transaction_history.items = get(resp, 'data', [])
          this.transaction_history.total = get(resp, 'total', 0)
          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.transaction_history.loading = false
        })
      },

      loadInfo () {
        this.loading = true
        this.users.loading = true

        return Promise.all([
          API.call('/kiosk/entities/info.json', { entity_id: this.entity_id }).then(resp => {
            this.entity = resp.data
            this.entityInit = cloneDeep(resp.data)
            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          }),
          API.call('/kiosk/users/list.json', { entity_id: this.entity_id }).then(resp => {
            this.users.items = resp.data
            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.users.loading = false
          })
        ])
      },

      transaction (type) {
        if (!this.$store.state.auth.checkAccess({ key: 'kiosk.entity.transfer_funds', value: true })) {
          return false
        }
        this.loading = true

        return API.call('/kiosk/entities/' + type + '.json', {
          entity_id: this.entity_id,
          ...this.balance
        }).then(resp => {
          this.entity = resp.data
          this.entityInit = cloneDeep(resp.data)

          return resp.data
        }).then(r => {
          return this.loadEntities()
        }).then(r => {
          return this.loadTransactionHistory()
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      saveUser () {
        if (!this.$store.state.auth.checkAccess({ key: 'kiosk.user.create', value: true })) {
          return false
        }
        this.users.loading = true
        API.call('/kiosk/users/create.json', { entity_id: this.entity_id, ...this.users.newUser }).then(resp => {
          this.users.createdModal = true
          return resp.data
        }).then(r => API.call('/kiosk/users/list.json', { entity_id: this.entity_id }).then(resp => {
          this.users.items = resp.data
          return resp.data
        })).catch(e => {
        }).finally(() => {
          this.users.loading = false
        })
      },

      async blockUser (user) {
        if (!this.$store.state.auth.checkAccess({ key: 'kiosk.user.create', value: true })) {
          return false
        }
        if (!await this.$root.$confirm('Confirm', `Block operator: ${user.login}`)) {
          return
        }
        this.users.loading = true
        API.call('/kiosk/users/delete.json', { entity_id: this.entity_id, ...user }).then(resp => {
          return resp.data
        }).then(r => API.call('/kiosk/users/list.json', { entity_id: this.entity_id }).then(resp => {
          this.users.items = resp.data
          return resp.data
        })).catch(e => {
        }).finally(() => {
          this.users.loading = false
        })
      },

      save () {
        if (!this.$store.state.auth.checkAccess({ key: 'kiosk.entity.crud', value: true })) {
          return false
        }
        this.loading = true

        let data = {}

        for (let k in this.entity) {
          if (this.create || (this.entity[k] != this.entityInit[k] && !isObject(this.entity[k]) && !isArray(this.entity[k]))) {
            data[k] = this.entity[k]
          }
        }

        if (this.entity_id) {
          data.entity_id = this.entity_id
        }

        return API.call('/kiosk/entities/' + this.action + '.json', data).then(resp => {
          if (resp.action) {
            this.action = resp.action
            this.create = false
            this.entity_id = resp.data.entity_id
          }

          this.entity = resp.data
          this.entityInit = cloneDeep(resp.data)

          return resp.data
        }).then(r => {
          return this.loadEntities()
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },
    },

  }
</script>
